'use strict';

var Easings = {
  BEZIER: 'cubic-bezier(.175, .885, .32, 1)',
  BEZIER_SPRINGY: 'cubic-bezier(.175, .885, .32, 1.15)'
};

module.exports = Easings;


/** WEBPACK FOOTER **
 ** ./constants/Easings.js
 **/